export default __webpack_public_path__ + "static/media/armin_m.03f41e2a.jpg";